/**
 * @generated SignedSource<<d6dd3cf962b16068b568879472b6eb6e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ProfileVisibilityEnum = "visibility_clients" | "visibility_private" | "visibility_public";
import { FragmentRefs } from "relay-runtime";
export type ProfileHireBox_BlogPostFragment$data = {
  readonly user: {
    readonly canMakeOffer: boolean | null | undefined;
    readonly id: string;
    readonly name: string | null | undefined;
    readonly profile: {
      readonly industry: {
        readonly name: string;
      } | null | undefined;
      readonly openToOpportunities: boolean | null | undefined;
      readonly slug: string | null | undefined;
      readonly visibility: ProfileVisibilityEnum | null | undefined;
    } | null | undefined;
    readonly video: {
      readonly " $fragmentSpreads": FragmentRefs<"Video_Video">;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"UserAvatarContainer_User">;
  } | null | undefined;
  readonly video: {
    readonly " $fragmentSpreads": FragmentRefs<"Video_Video">;
  } | null | undefined;
  readonly " $fragmentType": "ProfileHireBox_BlogPostFragment";
};
export type ProfileHireBox_BlogPostFragment$key = {
  readonly " $data"?: ProfileHireBox_BlogPostFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileHireBox_BlogPostFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "concreteType": "Video",
  "kind": "LinkedField",
  "name": "video",
  "plural": false,
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Video_Video"
    }
  ],
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileHireBox_BlogPostFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "canMakeOffer",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "UserAvatarContainer_User"
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Profile",
          "kind": "LinkedField",
          "name": "profile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "visibility",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "openToOpportunities",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "slug",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Industry",
              "kind": "LinkedField",
              "name": "industry",
              "plural": false,
              "selections": [
                (v1/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BlogPost",
  "abstractKey": null
};
})();

(node as any).hash = "1454272e534fcaef3c9bcb0c68ba90be";

export default node;
